

import Vue from 'vue'
import Component from 'vue-class-component'
import ErrorHandler from '@/services/ErrorHandlerService'
import { INotificationService } from '@/services/NotificationService'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import {User} from "@/models/user";
import UserService from "@/services/UserService";

const Props = Vue.extend({
  props: {
    onClose: Function,
  },
})

@Component({
  components: {
    ProgressLinear,
    GreenButton,
    RedButton,
    CardTitle,
  },
})

export default class ChangeActivationKey extends Props{
  private userAccount: User = {} as User
  private dialog: boolean = false
  private isPending: boolean = false
  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService
  private activationKey: string = ''

  public show(account: User) {
    this.activationKey = ''
    this.userAccount = account
    this.dialog = true
  }

  private hide() {
    this.onClose()
    this.dialog = false
  }

  private async changeActivationKey() {
      this.isPending = true
    try {
      this.activationKey = await UserService.changeActivationKey(this.userAccount.ad_personne_id, this.userAccount.identifiant)
      this.$notificationService.success(
          this.$t('USER.ChangeActivationKeySuccess').toString(),
      )
    } catch (error: any) {
      this.errorHandler.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
    }
    this.isPending = false
  }
}



